import axios from "axios";
import { config } from '../utils/api.config';

// Используем конфигурацию
const API_URL = config.apiUrl;
const DEFAULT_HOURLY_RATE = parseFloat(config.defaultHourlyRate) || 200;
const WS_URL = config.wsUrl;
const APP_NAME = config.appName;
const CURRENCY = config.currency;
const TIMEZONE = config.timezone;

// Экспортируем значения
export { 
    API_URL,
    DEFAULT_HOURLY_RATE,
    WS_URL,
    APP_NAME,
    CURRENCY,
    TIMEZONE
};

export const login = async (email, password) => {
  const response = await axios.post(`${API_URL}/login`, {
    email: email,
    password: password
  });
  // Просто сохраняем токен, остальное делается в компоненте
  localStorage.setItem('token', response.data.token);
  return response;
};

export const getDevices = async () => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}/api/devices`, {
    headers: {
      Authorization: token,
    },
  });
};

export const getDevice = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}/api/devices/${deviceId}`, {
    headers: {
      Authorization: token,
    },
  });
};

export const createDevice = async (deviceData) => {
  const token = localStorage.getItem("token");
  return axios.post(`${API_URL}/api/devices`, deviceData, {
    headers: {
      Authorization: token,
    },
  });
};

export const deleteDevice = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.delete(`${API_URL}/api/devices/${deviceId}`, {
    headers: {
      Authorization: token,
    },
  });
};

// Organization CRUD operations
export const getOrganizations = async () => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}/api/organizations`, {
    headers: {
      Authorization: token,
    },
  });
};

export const createOrganization = async (organizationData) => {
  const token = localStorage.getItem("token");
  return axios.post(`${API_URL}/api/organizations`, organizationData, {
    headers: {
      Authorization: token,
    },
  });
};

export const updateOrganization = async (organizationId, organizationData) => {
  const token = localStorage.getItem("token");
  return axios.put(`${API_URL}/api/organizations/${organizationId}`, organizationData, {
    headers: {
      Authorization: token,
    },
  });
};

export const deleteOrganization = async (organizationId) => {
  const token = localStorage.getItem("token");
  return axios.delete(`${API_URL}/api/organizations/${organizationId}`, {
    headers: {
      Authorization: token,
    },
  });
};

// ... остальные методы (streaming, api-key и т.д.) остаются без изменений ...

// Старый метод для управления стримом (остается для совместимости)
export const startDeviceStream = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.post(`${API_URL}/api/devices/${deviceId}/stream`, { "action": "start" }, {
    headers: {
      Authorization: token,
    },
  });
};

export const stopDeviceStream = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.post(`${API_URL}/api/devices/${deviceId}/stream`, { "action": "stop" }, {
    headers: {
      Authorization: token,
    },
  });
};

// Новые методы для системы оплаченного времени
export const addTimeToDevice = async (deviceId, hours) => {
  const token = localStorage.getItem("token");
  return axios.post(`${API_URL}/api/devices/${deviceId}/stream/add-time`, { 
    hours: hours 
  }, {
    headers: {
      Authorization: token,
    },
  });
};

export const forceStopStream = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.post(`${API_URL}/api/devices/${deviceId}/stream/stop`, {}, {
    headers: {
      Authorization: token,
    },
  });
};

export const getStreamTime = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}/api/devices/${deviceId}/stream/time`, {
    headers: {
      Authorization: token,
    },
  });
};

export const getStreamingStatus = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}/api/devices/${deviceId}/stream/status`, {
    headers: {
      Authorization: token,
    },
  });
};

export const getApiKey = async (deviceId) => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}/api/devices/${deviceId}/api-key`, {
    headers: {
      Authorization: token,
    },
  });
};

// Создание экземпляра axios с интерцепторами для обработки ошибок
const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;